import React, { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Box, Table, Thead, Tbody, Tr, Th, Td, Button, useToast } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import Api from '../../api/ApiUrl'; // Adjust to your API configuration
import CustomSpinner from './CustomSpinner';

const UsersTable = () => {
  const { subcategoryId } = useParams(); // Get subcategory ID from the URL
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
console.log(subcategoryId)
  const fetchUsers = async () => {
    try {
      const response = await fetch(`${Api}/api/v1/refundedDeposite/subcategory/${subcategoryId}/users`);
      console.log(response)
      const data = await response.json();
      setUsers(data.deposits);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching users:', error);
      toast({
        title: 'Error fetching users.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const refundAll = async () => {
    try {
      const response = await fetch(`${Api}/api/v1/refundedDeposite/subcategory/${subcategoryId}/refund`, {
        method: 'POST',
      });
      if (response.ok) {
        toast({
          title: 'Successfully refunded all users.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        fetchUsers(); // Refresh the users table after refund
      } else {
        throw new Error('Failed to refund all users');
      }
    } catch (error) {
      console.error('Error refunding all users:', error);
      toast({
        title: 'Error refunding all users.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const refundUser = async (userId) => {
    try {
      const response = await fetch(`${Api}/api/v1/refundedDeposite/subcategory/${subcategoryId}/refund/${userId}`, {
        method: 'POST',
      });
      console.log(response)
      if (response.ok) {
        toast({
          title: 'Successfully refunded the user.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        fetchUsers(); // Refresh the users table after refund
      } else {
        throw new Error('Failed to refund user');
      }
    } catch (error) {
      console.error('Error refunding user:', error);
      toast({
        title: 'Error refunding user.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [subcategoryId]);

  if (loading) return <CustomSpinner/>

  return (
    <Box>
      <Button colorScheme="blue" onClick={refundAll}>Refund All Users</Button>
      <Table mt={4}>
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Phone Number</Th>
            <Th>Subcategory Name</Th>
            <Th>Amount</Th>
            <Th>Status</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {users.map(user => (
            <Tr key={user._id}>
              <Td>{user.userId.name}</Td>
              <Td>{user.userId.phoneNumber}</Td>
              <Td>{user.item.name}</Td> {/* Subcategory name */}
              <Td>{user.amount}</Td> {/* Amount */}
              <Td>{user.status}</Td> 
              <Td>
                <Button colorScheme="red" onClick={() => refundUser(user.userId._id)}>Refund</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default UsersTable;
